import React from 'react'

function IndexTable(props) {
  return <div>IndexTable</div>
}

export default IndexTable
